export default __webpack_public_path__ + "static/media/FAMILY_CASE_LEFT_IMG.53130a9b.png";